import TranslationService from "../../../ceres/services/TranslationService";
import { isDefined } from "../../../ceres/helper/utils";
import { navigateTo } from "../../../ceres/services/UrlService";

const NotificationService = require("../../../ceres/services/NotificationService");

function _setConsent(state, { key, value }) {
	const groupKey = key.split(".")[0];
	const consentKey = key.split(".")[1];

	state.consents[groupKey] = state.consents[groupKey] || {};
	if (consentKey === "*") {
		Object.keys(state.consents[groupKey]).forEach(cKey => {
			state.consents[groupKey][cKey] = value;
		});
	} else {
		state.consents[groupKey][consentKey] = value;
	}
}

function setStateForConsents(state, changeTo) {
	Object.keys(state.consents || {}).forEach(groupKey => {
		if (typeof state.consents[groupKey] === "object") {
			Object.keys(state.consents[groupKey]).forEach(consentKey => {
				state.consents[groupKey] = state.consents[groupKey] || {};
				if (window.ConsentManager && !window.ConsentManager.isNecessary(`${groupKey}.${consentKey}`)) {
					state.consents[groupKey][consentKey] = changeTo;
				}
			});
		}
	});

	if (window.ConsentManager) {
		window.ConsentManager.setResponse(state.consents);
		state.hasResponse = true;
	}
}

function handleBacklink(backlink) {
	if (backlink !== null && backlink) {
		NotificationService.success(TranslationService.translate("Eros::Template.infoRedirect")).closeAfter(
			3000
		);
		navigateTo(decodeURIComponent(backlink));
	}
}

const state = () => ({
	consents: {},
	hasResponse: false,
	cookieBarToggle: false
});

const mutations = {
	toggleConsent(state, key) {
		_setConsent(state, { key: key, value: !this.getters.isConsented(key) });
	},
	setConsent(state, key, value) {
		_setConsent(state, { key, value });
	},
	toggleCookieBar(state) {
		state.cookieBarToggle = !state.cookieBarToggle;
	},
	setResponse(state, hasReponse) {
		state.hasResponse = hasReponse;
	},
	acceptAll(state) {
		setStateForConsents(state, true);
	},
	denyAll(state) {
		setStateForConsents(state, false);
	},
	initConsents(state) {
		if (window.ConsentManager) {
			state.consents = window.ConsentManager.getConsents();
		}
	}
};

const actions = {
	acceptAll({ state, dispatch, commit }, { showNotification = false, backlink = null }) {
		const hadNoResponse = !state.hasResponse;

		commit("acceptAll");

		if (window.ConsentManager) {
			window.ConsentManager.setResponse(state.consents);

			commit("setResponse", true);
			if (hadNoResponse) {
				dispatch("runIfConsented");
			}

			if (showNotification) {
				NotificationService.success(TranslationService.translate("Eros::Template.successSaved")).closeAfter(
					3000
				);
			}

			handleBacklink(backlink);
		}
	},
	denyAll({ state, dispatch, commit }, { showNotification = false, backlink = null }) {
		const hadNoResponse = !state.hasResponse;

		commit("denyAll");

		if (window.ConsentManager) {
			window.ConsentManager.setResponse(state.consents);
			commit("setResponse", true);
			if (hadNoResponse) {
				dispatch("runIfConsented");
			}

			if (showNotification) {
				NotificationService.success(TranslationService.translate("Eros::Template.successSaved")).closeAfter(
					3000
				);
			}

			handleBacklink(backlink);
		}
	},
	customiseCookies(__, useBacklink = false) {
		let path = App.urls.privacyPolicy;

		if (useBacklink && isDefined(document.location.href)) {
			path = path + "?backlink=" + encodeURIComponent(document.location.href);
		}

		navigateTo(path);
	},
	initConsents({ dispatch, commit }) {
		const hadReponse = window.ConsentManager.hasResponse();

		commit("initConsents");
		commit("setResponse", hadReponse);
		if (window.ConsentManager && hadReponse) dispatch("runIfConsented");
	},
	storeConsents({ state, dispatch, commit }, { showNotification = false, backlink = null }) {
		if (window.ConsentManager) {
			const hadNoResponse = !state.hasResponse;

			window.ConsentManager.setResponse(state.consents);
			commit("setResponse", true);
			if (hadNoResponse) {
				dispatch("runIfConsented");
			}
		}

		if (showNotification) {
			NotificationService.success(TranslationService.translate("Eros::Template.successSaved")).closeAfter(8000);
		}

		handleBacklink(backlink);
	}
};

const getters = {
	isConsented: state => key => {
		const groupKey = key.split(".")[0];
		const consentKey = key.split(".")[1];

		if (consentKey === "*") {
			return Object.keys(state.consents[groupKey] || {}).some(consentKey => {
				return (state.consents[groupKey] || {})[consentKey];
			});
		}

		return (state.consents[groupKey] || {})[consentKey];
	}
};

export default {
	state,
	mutations,
	actions,
	getters
};
